<template>
	<div class="clear">
		<div class="content">
			<div class="page-tab">
				<el-select v-model="projId" placeholder="暂无数据..." size="small" :loading="loading" @change="selectProj"  :popper-append-to-body="false" ref="webSelect" automatic-dropdown >
					<el-option v-for="(item, i) in pageList" :key="i" :label="item.projName" :value="item.id"></el-option>
				</el-select>
				<el-button type="primary" class="page-btn" @click="webSwitch" size="small">切换站点</el-button>
			</div>
			<div class="reset-account"><a @click="jumpSetBaiduAccount('statistics')">修改绑定账号</a></div>
		</div>
		<yq-dialog-hint :showDialog.sync="showDialog" :config="dialogConfig" @defined="definedBack"></yq-dialog-hint>
		<serviceUpgradeDialog v-if="upgradeConfig.show" :upgradeConfig="upgradeConfig"></serviceUpgradeDialog>
	</div>
</template>

<script>
import {
	mapActions,
	mapGetters,
	mapMutations,
	mapState
} from 'vuex'
import serviceUpgradeDialog from '../../component/ServiceUpgradeDialog'
import mixinsDialog from '../../../mixins/mixinsDialog.js'
import moment from 'moment'
export default {
	name: 'ProjSelect',
	components: {
		serviceUpgradeDialog
	},
	data () {
		return {
			pageList: [],
			loading: false,
			upgradeConfig: {},
			isVisible: false
		}
	},
	mixins: [mixinsDialog],
	created () {
		this.getList()
	},
	computed: {
		...mapGetters('user', ['userInfo']),
		...mapState('siteStas', ['curProjId', 'errAccountInfo']),
		...mapGetters('siteStas', ['getErrTips']),
		projId: {
			get () {
				return this.curProjId || ''
			},
			set (val) {
				this.setCurProjId(val)
			}
		}
	},
	methods: {
		...mapActions('siteList', ['getProjList']),
		...mapActions('siteStas', ['getSiteRelation', 'getRealtime', 'getDaily', 'getBaiduAccount']),
		...mapMutations('siteStas', ['setCurProjId', 'setDataPickerData', 'setAccountData', 'setFlowData',
			'modifyDateDataAct', 'setErrAccountInfo'
		]),
		openUpgrade () {
			if (this.userInfo.role === 'user') {
				this.upgradeConfig = {
					show: true,
					upgradeInfo: 'system2'
				}
			} else {
				if (this.pageList.length === 0) {
					this.openErrDialog('warn', '操作信息提示', 'jumpPageList', '', '您还没有创建站点，暂无法使用流量统计', '立即创建')
				} else {
					this.openErrDialog('warn', '操作信息提示', 'jumpSetBaiduAccount', this.getErrTips.jumpCur, this
						.getErrTips.info, this.getErrTips.btnName)
				}
			}
		},
		jumpPageList () {
			this.$router.push({
				name: 'pageList',
				params: {
					tblType: 'PC'
				}
			})
		},
		cancelUpgrade () {
			this.upgradeConfig.show = false
		},
		init (projId) {
			let oneDay = moment().format('YYYY-MM-DD')
			this.setDataPickerData({
				oneDay
			})
			this.modifyDateDataAct('today')
			this.getSiteRelation().then(data => {
				this.setAccountData(data)
				this.getRealtime()
				this.getAccountInfo(projId)
			}, err => {
				this.setErrAccountInfo(err)
				this.openUpgrade()
			})
		},
		getList () {
			this.loading = true
			let params = {
				userId: this.userInfo.uid,
				status: 0,
				pageSize: 1000,
				pageNum: 1
			}
			this.getProjList(params).then(res => {
				this.loading = false
				if (res.isSuccess) {
					this.pageList = res.data.list
					if (res.data.list.length > 0) {
						this.handleProjData()
					} else {
						this.openUpgrade()
					}
				} else {
					this.$message.error(res.message)
				}
			})
		},
		async getAccountInfo (projId) {
			let {
				data
			} = await this.getBaiduAccount({
				projectId: projId
			})
			if (data.isSuccess) {
				this.setFlowData(data.data)
			} else {
				this.setFlowData({})
				this.$message.error('获取信息失败')
			}
		},
		handleProjData () {
			let projId = this.$route.query.projId
			if (!projId) {
				this.projId = this.pageList[0].id
			} else {
				this.projId = projId
			}
			this.init(this.projId)
		},
		selectProj (projId) {
			this.$router.push({
				name: 'flowInfo',
				query: {
					projId: projId
				}
			})
			this.init(projId)

		},
		routerJump (projId) {
			const originRouter = this.$router.resolve({
				name: 'flowInfo',
				query: {
					projId
				}
			})
			window.location.href = originRouter.href
		},
		jumpSetBaiduAccount (curTab = 'statistics') {
			if (curTab === 'jumpBaidu') {
				window.open('https://tongji.baidu.com/web/welcome/login')
				return
			}
			let curProj = this.pageList.find(item => item.id === this.projId)
			const originRouter = this.$router.resolve({
				name: 'template',
				query: {
					edit: true,
					projId: curProj.id,
					type: curProj.projType == 'PC' ? 'pctype' : 'mctype',
					prodType: curProj.prodType,
					// config: 'istrue',
					curTab: curTab
				}
			})
			window.localStorage.setItem('isConfig', 'isConfig')
			window.open(originRouter.href)
		},
		webSwitch(){
			if(this.isVisible){
				this.$refs.webSelect.blur()
			}else{
				this.$refs.webSelect.focus()
			}
			this.isVisible =  !this.isVisible
		}
	}
}

</script>

<style scoped lang="scss">
.page-tab .el-select {
	width: 420px;
}

.clear {
	height:60px;
	background:#fff;
	border-radius:4px;
	clear: both;
	padding: 0 75px 0 18px;
	margin-bottom: 20px;

}
.content{
	height:60px;
	display: flex;
	justify-content: space-between;
	align-items: center;

}
.page-btn{
	width:100px;
	border-radius:2px;
}
.reset-account {

	color: $colorA;
	cursor: pointer;
	text-decoration: underline;
	line-height: 40px;
}
</style>
